<script>
  import nl2br from "vue-nl2br";
  import EdaCard from "../components/vCardGeneric"
  import EdaOrderLine from "../components/vOrderLine"
  import EdaStatus from "../components/vStatus"
  import EdaLink from "../components/vLink"
  import date from "../components/vDateInput"
  import EdaIcon from "../components/vIcon"
  import transformers from "../transformers/transformers"
  import apiMixin from "../mixins/apiMixin"
  import { mapGetters } from "vuex"
  import axios from "axios"
  import EdaEllipsisLoader from "../components/vEllipsisLoader"
  import inp from "../components/vInput";
  import val from "../components/vValue";
  import but from "../components/vButton";
  import tex from "../components/vTextarea";
  import buttonPair from "../components/vButtonPair"
  import vSettingBinary from "../components/vSettingBinary"
  import vSetting from "../components/vSetting"
  import vSettingDropdown from "../components/vSettingDropdown"
  import vInstallerLookup from "../components/vInstallerLookup"

  import PORTAL from "../config/portals/config.js"
  import STATUS from "../config/status/order.js"
  import INSTALLER_STATUS from "../config/status/installer.js"
  import ADMIN_INSTALLER_STATUS from "../config/status/adminInstaller.js"
  import APPROVALSTATUS from "../config/houseapproval/config.js"
  import FLAGS from "../config/flags/config.js"


  export default {
    name: "EdaOrder",
    mixins: [
      transformers.solutionCardTransformer,
      apiMixin.apiMixin
    ],
    components: {
      nl2br,
      EdaEllipsisLoader,
      EdaCard,
      EdaOrderLine,
      EdaStatus,
      EdaLink,
      EdaIcon,
      but,
      buttonPair,
      vSettingBinary,
      vInstallerLookup,
      vSetting,
      vSettingDropdown,
      tex,
      val,
      inp,
      date,
    },
    props: {
      id: { type: String, default: "" },
      secret: { type: String, default: "" },
      editable: { type: Boolean, default: false },
      showPrices: { type: Boolean, default: true }
    },
    data: function () {
      return {
        copySucceeded: false,
        sharing: false,
        requests: {},
        loaded: false,
        order: {},
        rollback: {},
        patch: {},
        saving: [],
        failed: [],
        editing: {
          retailerOrderRef: false,
          contact: false,
          address: false,
          orderLines: false,
          installationDate: false,
          additionalInfo: false,
          retailerNotes: false,
          houseApproval: false,
          adminNotes: false
        }
      }
    },
    computed: {
      ...mapGetters([
        "getField",
        "getUser",
        "getCurrentSolution"
      ]),
      canEdit() {
        return this.editable && this.getUser.groups.indexOf("edaAdmin") != -1;
      },
      salesPerson() {
        let slp = this.order.retailerSalesPerson;

        return {
          "url": "mailto:" + slp.email,
          "displayName": slp.fullName.length ? slp.fullName : slp.email,
          "telephone": slp.telephone,
        }
      },
      total() {
        let total = 0;

        if (this.order !== {}) {
          for (let i in this.order.orderLines) {
            total = total + this.order.orderLines[i].lineTotal;
          }
        }
        return total;
      },


      flagOptions() {
        return FLAGS.reduce(function (result, item) {
          result[item.value] = item;
          return result;
        }, {})
      },

      statusOptions() {
        return STATUS
      },


      installerStatusOptions() {
        return this.secret.length ? INSTALLER_STATUS : ADMIN_INSTALLER_STATUS;
      },

      houseApprovalOptions() {
        return APPROVALSTATUS;
      },

      portalOptions() {
        return PORTAL;
      },

      totalVat() {
        let vat = 0;

        if (this.order !== {}) {
          for (let i in this.order.orderLines) {
            vat = vat + this.order.orderLines[i].vat;
          }
        }
        return Math.round(vat);

      },


      solutionCardData() {
        let trafo = this.solutionCardTransform(this.order);
        trafo.onClick = function () {
        };
        return trafo;
      },

      isEditable() {
        return !['completed'].includes(this.order.orderStatus)
      },

      locationMapsLink() {
        return "https://maps.google.com/?q=" + this.order.customerAddressLine1 + ", " + this.order.customerPostcode;
      },

      shareUrl() {
        var port = window.location.port.length && window.location.port.length != 80 ? ":" + window.location.port : ""
        return window.location.protocol + "//" + window.location.hostname + port + "/#/orders/share/" + this.order.secret;
      }
    },

    watch: {
      /*   'order.administratorAttentionNeeded': function () {
             this.patchSection(["administratorAttentionNeeded"]);
         },

         'order.retailerAttentionNeeded': function () {
             this.patchSection(["retailerAttentionNeeded"]);
         },

         'order.orderStatus': function () {
             this.patchSection(["orderStatus"]);
         }
         */


    },

    methods: {
      field(store, field) {
        return this.getField({ 'store': store, 'key': field });
      },
      submitOrder() {
        this.$router.push("/orders/1000/add-accessories");
      },

      isSaving(field) {
        if (this.saving.indexOf(field) !== -1) {
          return true;
        }
        return false;
      },

      createBackup() {
        this.rollback = Object.assign({}, this.order);
      },

      restoreBackup() {
        this.patch = Object.assign({}, this.rollback);
        this.order = Object.assign({}, this.rollback);
      },

      saveSection(sectionName, fields) {
        this.createBackup();

        for (var key in fields) {
          this.order[fields[key]] = this.patch[fields[key]];
        }

        if (sectionName != null) {
          this.editing[sectionName] = false;
        }
        this.patchSection(fields);
      },

      saveOrderLinesPatch() {
        console.log("patching orderlines");

      },

      patchSection(fields) {


        console.log("patching", fields);
        this.saving.push(...fields);
        var values = {};

        for (var key in fields) {
          values[fields[key]] = this.order[fields[key]];
          // store that we are about to save on this fields to give feedback to user
        }

        var that = this;

        if (values.hasOwnProperty("installationDate")) {
          values.installationDate = values.installationDate.date;
        }


        // transform from object to AX-number string
        if (values.hasOwnProperty("installationPartner")) {
          values.installationPartner = values.installationPartner.id;
        }


        if (values.hasOwnProperty("orderLines")) {
          let olData = [];
          for (let key in values.orderLines) {
            olData.push({ "id": values.orderLines[key].id, "quantity": values.orderLines[key].quantity });
          }
          values.orderLines = olData;
        }


        if (this.secret.length) {
          values["secret"] = this.secret;
        }

        let id = that.secret.length ? that.secret : that.id;

        axios.patch(process.env.VUE_APP_API_URL + "/orders/" + id, values, that.apiHeaders)
          .then(function (response) {
            that.failed.pop(...fields);

          }).catch(function (response) {

          console.log("restoring backup", that.rollback);
          that.restoreBackup();
          that.failed.push(...fields);

        }).finally(function (response) {
          console.log("finnaly getting here");
          that.saving.pop(...fields);
        });

      },


      handleCopySuccess() {
        this.copySucceeded = true;
      },

      prepOrder(order) {

        for (var key in order.orderLines) {
          // order.orderLines[key].price = // order.orderLines[key].price);
          // order.orderLines[key].quantity = // parseFloat(order.orderLines[key].quantity);
        }

        if (order.retailerCustomerId == null) {
          order.retailerCustomerId = "";
        }

        if (order.administratorNotes == null) {
//                    order.administratorNotes = "";
        }

        if (order.installationDate == null) {
          console.log("installationDate is null")
          order.installationDate = { date: null }
        }
        return order;

      }

    },

    mounted: function () {
      var that = this;
      let headers = this.apiHeaders;

      let endpoint = this.secret.length ? process.env.VUE_APP_API_URL + "/orders/" + this.secret : process.env.VUE_APP_API_URL + "/orders/" + this.id;

      axios.get(endpoint, headers).then(function (response) {

        let preppedData = that.prepOrder(response.data);

        that.order = preppedData;

        that.patch = Object.assign({}, that.order);

        that.loaded = true;
      }).catch(function (error) {
        // if(error.response.status == 401){
        // }
        console.log(error);
      });
    }

  }
</script>

<template>
    <div class="eda-order">
        <template v-if="!loaded">
            <h1 class="eda-order__heading">
                <eda-ellipsis-loader></eda-ellipsis-loader>
            </h1>
        </template>
        <template v-else>

            <h1 class="eda-order__heading">
                {{ $t('order.heading', {orderRef: order.title})}}
            </h1>


            <div class="eda-order__meta">

                <div class="eda-order__retailer eda-order__meta-item">
                    <div class="eda-order__meta-heading">
                        {{ $t('order.meta.retailer.heading') }}
                    </div>

                    <div class="eda-order__meta-value">
                        {{ order.retailer }}
                    </div>
                </div>


                <div class="eda-order__retailer eda-order__meta-item">
                    <div class="eda-order__meta-heading">
                        {{ $t('order.meta.retailer.salesPerson.heading') }}
                    </div>

                    <div class="eda-order__meta-value">
                        <eda-link :href="salesPerson.url"> {{ salesPerson.displayName }}</eda-link>
                    </div>
                    <div class="eda-order__meta-value" v-if="salesPerson.telephone.length">
                        {{ $t('order.meta.retailer.salesPerson.telephone.heading') }}

                        <eda-link :href="'tel:' + salesPerson.telephone">{{ salesPerson.telephone }}</eda-link>
                    </div>
                </div>
                <div class="eda-order__created eda-order__meta-item">
                    <div class="eda-order__meta-heading">
                        {{ $t('order.meta.createdDate.heading') }}
                    </div>
                    <div class="eda-order__meta-value">
                        {{ order.created.date | formatDate }} {{ order.created.date | formatTime }}
                    </div>
                </div>


                <div class="eda-order__updated eda-order__meta-item">
                    <div class="eda-order__meta-heading">
                        {{ $t('order.meta.updatedDate.heading') }}
                    </div>
                    <div class="eda-order__meta-value">
                        {{ order.updated.date | formatDate }} {{ order.updated.date | formatTime }}
                    </div>
                </div>


                <div class="eda-oder__share eda-order__meta-item" v-if="canEdit">
                    <eda-link @click="sharing = !sharing">
                        {{ $t('order.meta.share.link') }}
                    </eda-link>
                </div>

                <!--
                                <div class="eda-order__updated eda-order__meta-item" v-if="isEditable">
                                    <eda-link :to="'/order/' + id + '/update'">Endre Bestilling</eda-link>
                                </div>
                                -->

            </div>


            <div class="eda-order__sharing" :class="{'eda-order__sharing--visible': sharing}" v-if="canEdit">

                <h2 class="eda-order__share-header">
                    {{ $t('order.meta.share.heading') }}
                </h2>
                <eda-link target="_blank" :href="shareUrl">{{shareUrl}}</eda-link>

                <div class="eda-order__clipboard">
                    <but :label="copySucceeded ?  $t('order.meta.share.copySuccess') : $t('order.meta.share.copyToClipboard')"
                         :secondary="true"
                         v-clipboard:copy="shareUrl"
                         v-clipboard:success="handleCopySuccess">

                    </but>
                </div>

            </div>

            <div class="eda-order__panes">

                <div class="eda-order__pane">
                    <template v-if="secret.length">
                        <div class="eda-order__setting eda-order__setting--highlight">
                            <v-setting-dropdown
                                    :label="$t('order.installationStatus.installerHeading')"
                                    :options="installerStatusOptions"
                                    :failed="failed.includes('installationStatus')"
                                    :loading="saving.includes('installationStatus')"
                                    @input="saveSection(null, ['installationStatus'])"
                                    v-model="patch.installationStatus">
                            </v-setting-dropdown>
                        </div>
                    </template>


                    <div class="eda-order__setting">
                        <v-setting-binary :label="flagOptions.administratorAttentionNeeded.label"
                                          :disabled="!editable"
                                          @input="patchSection(['administratorAttentionNeeded'])"
                                          v-model="order.administratorAttentionNeeded"></v-setting-binary>
                    </div>

                    <div class="eda-order__setting">
                        <v-setting-binary :label="flagOptions.retailerAttentionNeeded.label"
                                          :disabled="!editable"
                                          @input="patchSection(['retailerAttentionNeeded'])"
                                          v-model="order.retailerAttentionNeeded"></v-setting-binary>
                    </div>

                    <div class="eda-order__setting">
                        <v-setting-dropdown label="Status"
                                            :disabled="!canEdit"
                                            :options="statusOptions"
                                            @input="patchSection(['orderStatus'])"
                                            v-model="order.orderStatus"></v-setting-dropdown>
                    </div>

                 <!--   <div class="eda-order__setting">
                        <v-setting label="Installatør">
                            <v-installer-lookup
                                    :zip="order.customerPostcode"
                                    v-model="order.installationPartner"
                                    @input="patchSection(['installationPartner'])"/>
                        </v-setting>
                    </div>
                    -->

                    <template v-if="!secret.length">
                        <div class="eda-order__setting">
                            <v-setting-dropdown
                                    :label="$t('order.installationStatus.adminHeading')"
                                    :options="installerStatusOptions"
                                    :disabled="true"
                                    v-model="patch.installationStatus"></v-setting-dropdown>
                        </div>
                    </template>


                    <div class="eda-order__section">
                        <div class="eda-order__edit-section" @click="editing.contact = true" v-if="canEdit">
                            <eda-icon icon="pencil" fill="black"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                         <span>
                            {{ $t('order.customer.heading') }}
                        </span>
                            <span class="eda-order__retailer-customer-ref">
                        <val :visible="!editing.contact">
                             FK-id:
                            {{ order.retailerCustomerId != null && order.retailerCustomerId.length ? order.retailerCustomerId : "-" }}
                        </val>
                            </span>

                        </h2>

                        <div class="eda-order__full-name">
                            <val :visible="!editing.contact"> {{ order.customerFullName }}</val>
                        </div>
                        <div class="eda-order__row">
                            <div class="eda-order__phone">
                                <val :visible="!editing.contact">
                                    {{ $t('order.customer.telephone', {number: order.customerPhone}) }}
                                </val>
                            </div>
                            <div class="eda-order__email">
                                <val :visible="!editing.contact">
                                    <eda-link :href="'mailto:' + order.customerEmail ">{{ order.customerEmail }}
                                    </eda-link>
                                </val>
                            </div>
                        </div>


                        <template v-if="canEdit">
                            <inp label="Fullt navn" :visible="editing.contact" v-model="patch.customerFullName"></inp>
                            <inp label="Telefon" :visible="editing.contact" v-model="patch.customerPhone"></inp>
                            <inp label="Epost" :visible="editing.contact" v-model="patch.customerEmail"></inp>
                            <inp label="Forhandlers kunde-ID" :visible="editing.contact"
                                 v-model="patch.retailerCustomerId"></inp>

                            <button-pair :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                         :visible="editing.contact"
                                         @primary-click="saveSection('contact', ['customerFullName','customerPhone','customerEmail', 'retailerCustomerId'])"
                                         @secondary-click="editing.contact = false">
                            </button-pair>
                        </template>

                    </div>


                    <div class="eda-order__section">
                        <div class="eda-order__edit-section" @click="editing.address = true" v-if="canEdit">
                            <eda-icon icon="pencil"></eda-icon>
                        </div>

                        <h2 class="eda-order__h2">
                            {{ $t('order.installationAddress.heading') }}
                        </h2>

                        <div class="eda-order__address">
                            <val :visible="!editing.address"> {{ order.customerAddressLine1 }}</val>
                        </div>

                        <div class="eda-order__location">
                            <div class="eda-order__postcode">
                                <val :visible="!editing.address"> {{ order.customerPostcode }}</val>
                            </div>
                            <div class="eda-order__place">
                                <val :visible="!editing.address"> {{ order.customerPlace }}</val>
                            </div>

                            <div class="eda-order__google-maps">
                                <val :visible="!editing.address">
                                    <eda-link target="_blank" :href="locationMapsLink">
                                        {{ $t('order.installationAddress.goToMap') }}
                                    </eda-link>
                                </val>
                            </div>
                        </div>


                        <template v-if="canEdit">
                            <inp label="Vei og nummer"
                                 name="addressLine1"
                                 :visible="editing.address"
                                 v-model="patch.customerAddressLine1"></inp>
                            <inp label="Postnummer" :visible="editing.address" v-model="patch.customerPostcode"></inp>
                            <inp label="Sted" :visible="editing.address" v-model="patch.customerPlace"></inp>

                            <button-pair
                                    :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                    :visible="editing.address"
                                    @primary-click="saveSection('address', ['customerAddressLine1','customerPostcode','customerPlace'])"
                                    @secondary-click="editing.address = false">
                            </button-pair>
                        </template>

                    </div>

                    <div class="eda-order__section">

                        <h2 class="eda-order__h2">
                            {{ $t('order.houseApproved.heading') }}
                        </h2>

                        <div class="eda-order__approved">
                            {{ houseApprovalOptions.find(opt => opt.value == order.approvedByHouseOwner).label }}
                        </div>
                    </div>


                    <div class="eda-order__section" v-if="order.customerCarDeliveryDate != null">
                        <h2 class="eda-order__h2">
                            {{ $t('order.carDeliveryDate.heading') }}
                        </h2>
                        <div class="eda-order__value">
                            {{ order.customerCarDeliveryDate.date | formatDate }}
                        </div>
                    </div>


                    <div class="eda-order__section">
                        <h2 class="eda-order__h2">
                            {{ $t('order.car.heading') }}
                        </h2>
                        <div class="eda-order__value">
                            {{ order.customerCarBrand }}
                            {{ order.customerCarModel }}
                        </div>
                    </div>

                </div>


                <div class="eda-order__pane">
                    <div class="eda-order__section">
                        <div class="eda-order__edit-section" @click="editing.orderLines = true" v-if="false && canEdit">
                            <eda-icon icon="pencil" fill="black"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                            {{ $t('order.summary.heading') }}
                        </h2>

                        <template v-if="!editing.orderLines">
                            <template v-for="line in order.orderLines">
                                <eda-order-line v-bind="line" :show-price="showPrices"></eda-order-line>
                            </template>


                            <div class="eda-order__total" v-if="total && showPrices">
                                {{ $t('order.summary.total') }}
                                <span class="eda-order__amount"> {{ total }},- </span>
                            </div>

                            <div class="eda-order__vat" v-if="totalVat && showPrices">
                                {{ $t('order.summary.vat') }} <span class="eda-order__amount">{{ totalVat }},- </span>
                            </div>
                        </template>

                        <template v-if="canEdit">

                            <template v-for="line in patch.orderLines">
                                <inp label="Elnummer" :visible="editing.orderLines" v-model="line.id"></inp>
                            </template>


                            <button-pair
                                    :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                    :visible="editing.orderLines"
                                    @primary-click="saveSection('orderLines', ['orderLines'])"
                                    @secondary-click="editing.orderLines = false">
                            </button-pair>
                        </template>
                    </div>

                    <div class="eda-order__section">
                        <div class="eda-order__edit-section" @click="editing.retailerOrderRef = true" v-if="canEdit">
                            <eda-icon icon="pencil" fill="black"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                            {{ $t('order.retailer.reference') }}
                        </h2>

                        <val :visible="!editing.retailerOrderRef">
                            {{ order.retailerOrderRef.length ? order.retailerOrderRef : "-" }}
                        </val>

                        <template v-if="canEdit">

                            <inp label="Bestillingsreferanse" :visible="editing.retailerOrderRef"
                                 v-model="patch.retailerOrderRef"></inp>

                            <button-pair
                                    :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                    :visible="editing.retailerOrderRef"
                                    @primary-click="saveSection('retailerOrderRef', ['retailerOrderRef'])"
                                    @secondary-click="editing.retailerOrderRef = false">
                            </button-pair>
                        </template>
                    </div>


                    <div class="eda-order__section">

                        <div class="eda-order__edit-section"
                             v-if="canEdit"
                             :class="{'eda-order__edit-section--hidden': editing.additionalInfo}"
                             @click="editing.additionalInfo = true">
                            <eda-icon icon="pencil"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                            {{ $t('order.customer.details') }}
                        </h2>


                        <val :visible="!editing.additionalInfo" :maxHeight="false">
                            <nl2br tag="p" :text="(order.orderNotes.length ? order.orderNotes : '-')"></nl2br>
                        </val>

                        <template v-if="canEdit">
                            <tex v-show="editing.additionalInfo" v-model="patch.orderNotes"></tex>
                            <button-pair
                                    :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                    :visible="editing.additionalInfo"
                                    @primary-click="saveSection('additionalInfo', ['orderNotes'])"
                                    @secondary-click="editing.additionalInfo = false">
                            </button-pair>
                        </template>
                    </div>

                    <div class="eda-order__section">
                        <div class="eda-order__edit-section"
                             v-if="canEdit"
                             :class="{'eda-order__edit-section--hidden': editing.retailerNotes}"
                             @click="editing.retailerNotes = true">
                            <eda-icon icon="pencil"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                            {{ $t('order.retailer.details') }}
                        </h2>


                        <val :visible="!editing.retailerNotes" :maxHeight="false">
                            <nl2br tag="p" :text="(order.retailerNotes.length ? order.retailerNotes : '-')"></nl2br>
                        </val>

                        <template v-if="canEdit">
                            <tex v-show="editing.retailerNotes" v-model="patch.retailerNotes"></tex>
                            <button-pair :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                         :visible="editing.retailerNotes"
                                         @primary-click="saveSection('retailerNotes', ['retailerNotes'])"
                                         @secondary-click="editing.retailerNotes = false">
                            </button-pair>
                        </template>
                    </div>


                    <div class="eda-order__section" v-if="order.hasOwnProperty('administratorNotes')">

                        <div class="eda-order__edit-section"
                             v-if="canEdit"
                             :class="{'eda-order__edit-section--hidden': editing.adminNotes}"
                             @click="editing.adminNotes = true">
                            <eda-icon icon="pencil"></eda-icon>
                        </div>
                        <h2 class="eda-order__h2">
                            {{ $t('order.admin.details', {admin: portalOptions.admin.name }) }}
                        </h2>


                        <val :visible="!editing.adminNotes" :maxHeight="false">
                            <nl2br tag="p"
                                   :text="(order.administratorNotes.length ? order.administratorNotes : '-')"></nl2br>
                        </val>

                        <template v-if="canEdit">
                            <tex v-show="editing.adminNotes" v-model="patch.administratorNotes"></tex>
                            <button-pair :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                                         :visible="editing.adminNotes"
                                         @primary-click="saveSection('adminNotes', ['administratorNotes'])"
                                         @secondary-click="editing.adminNotes = false">
                            </button-pair>
                        </template>
                    </div>


                </div>
            </div>
        </template>
    </div>

</template>

<style lang="scss">

    .eda-order {

        &__setting {
            padding: 0 2em;
            border-bottom: 1px solid #eee;

            &--highlight {
                color: white;
                background-color: #00B27C;
            }
        }
    }

    .eda-order__panes {
        justify-content: center;
        display: flex;
        width: 100%;
        color: #585858;
    }

    .mq-tablet .eda-order__panes,
    .mq-mobile .eda-order__panes {
        flex-direction: column;
        align-items: center;
    }

    .eda-order__pane {
        margin: 0.1%;
        max-width: 30em;
        width: 49.9%;
        flex: none;
        padding-bottom: 2em;
        background-color: white;
    }

    .mq-tablet .eda-order__pane,
    .mq-mobile .eda-order__pane {
        width: 100%;

    }

    .eda-order__sharing {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 0 2em;
        width: 100%;
        max-width: calc(60em + 0.2%);
        margin: 0 auto;
        background-color: white;
        max-height: 0;
        opacity: 0;
        transition: 0.2s ease all;
    }

    .eda-order__sharing--visible {
        max-height: 24em;
        padding: 2em 2em;
        opacity: 1;
        margin: 0 auto 1em auto;
    }

    .eda-order__clipboard {
        padding-top: 1.5em;
    }

    .eda-order__retailer-customer-ref {
        font-weight: 300;
        color: #AAA;
        margin-left: 1em;
        font-size: 0.8em;
        display: inline-block;
    }

    .eda-order__change {
        font-weight: 300;
        padding-top: 0.75em;
        font-size: 0.8em;
        color: #9b9c9d;
    }

    .eda-order__heading {

        margin-bottom: 1em;
        font-weight: 500;
        width: 100%;
        text-align: center;
        color: white;
    }

    .mq-tablet .eda-order__heading,
    .mq-mobile .eda-order__heading {
        font-size: 1.5em;
    }

    .eda-order__meta {
        color: #CFCFCF;
        display: flex;
        justify-content: center;
        font-size: 0.85em;
        font-weight: 300;
        padding-bottom: 3em;
    }

    .eda-order__meta-heading {
        font-weight: 600;
        font-size: .85em;
    }

    .mq-tablet .eda-order__meta,
    .mq-mobile .eda-order__meta {
        flex-direction: column;
        align-items: center;
    }

    .eda-order__edit-section {
        opacity: 0;
        position: absolute;
        top: 1em;
        right: 2em;
        width: 2em;
        padding: 0.25em 0.55em;
        border-radius: 2em;
        transition: all 0.2s ease;
        cursor: pointer;
        fill: #777;

    }

    .eda-order__edit-section:hover {
        background-color: #00B27C;
        fill: white;
    }

    .eda-order__section:hover .eda-order__edit-section {
        opacity: 1;
    }

    .eda-order__section:hover .eda-order__edit-section--hidden {
        opacity: 0;
        pointer-events: none;

    }

    .eda-order__meta-item {
        padding: 0 1.5em;
    }

    .eda-order__section {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: .5em 2em 1em 2em;
    }

    .eda-order__address,
    .eda-order__full-name {
        font-size: 1.3em;

    }

    .eda-order__location {
        display: flex;

    }

    .eda-order__location-icon {
        fill: #00B27C;
        position: absolute;
        left: 0;
        bottom: 0.5em;
        width: 1.75em;
    }

    .eda-order__phone {
        padding-right: 1em;
    }

    .eda-order__place {
        padding-left: 1em;
    }

    .eda-order__google-maps {
        width: auto;
        padding-left: 1em;
        position: relative;
    }

    .eda-order__notes,
    .eda-order__email,
    .eda-order__phone {
        font-size: 0.95em;
    }

    .eda-order__h2 {
        display: flex;

        align-items: center;
        margin-bottom: 0.25em;
        margin-top: 0.5em;
        font-size: 1em;
        color: #263926;
        font-weight: 600;
    }

    .eda-order__status {
        font-weight: 600;
        line-height: 1;
        font-size: 1.25em;
    }

    .eda-order__buttons--invisible {
        padding: 0;
        margin: 0;
    }

    .eda-order__vat,
    .eda-order__total {
        width: 100%;
        text-align: right
    }

    .eda-order__total {
        font-weight: 600;
        padding-top: 1em;
        font-size: 1.1em;
        color: #263926;
    }

    .eda-order__vat {
        padding-top: 0.25em;
        font-weight: 300;
        color: #949494;
        font-size: 0.9em;
    }

    .eda-order__amount {
        font-weight: 600;
        font-size: 1.2em;
        padding-left: 1em
    }

    .eda-order__row {
        display: flex;
    }

    .eda-order__submit {
        padding-top: 2em;
    }

    .eda-order__div {
        border: none;
        padding: 0.5em 0;
    }

    .eda-order__fieldgroup {
        display: flex;
        justify-content: space-between;

    }


</style>